"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UINT_256_MAX = exports.UINT_128_MAX = exports.UINT_160_MAX = exports.UINT_80_MAX = exports.UINT_40_MAX = exports.UINT_32_MAX = exports.UINT_24_MAX = exports.UINT_8_MAX = void 0;
exports.UINT_8_MAX = (1n << 8n) - 1n;
exports.UINT_24_MAX = (1n << 24n) - 1n;
exports.UINT_32_MAX = (1n << 32n) - 1n;
exports.UINT_40_MAX = (1n << 40n) - 1n;
exports.UINT_80_MAX = (1n << 80n) - 1n;
exports.UINT_160_MAX = (1n << 160n) - 1n;
exports.UINT_128_MAX = (1n << 128n) - 1n;
exports.UINT_256_MAX = (1n << 256n) - 1n;
//# sourceMappingURL=constants.js.map